import 'buefy/dist/buefy.css'
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import SmoothScrollbar from 'vue-smooth-scrollbar'
import Vue from 'vue'
import App from './app.vue'
import router from './router'
import store from './store'
import Buefy from 'buefy'
import VueCookies from 'vue-cookies'
import HelperMixin from "./error.mixin";
import Truncate from "./truncate.filter";
import './registerServiceWorker'
Vue.mixin(HelperMixin);

Vue.directive("focus", {
  inserted: function(el) {
    el.focus();
  },
});

Vue.use(VueCookies)
Vue.use(SmoothScrollbar)
Vue.use(Buefy)
Vue.config.productionTip = false
Vue.component('treeselect', Treeselect)
Vue.filter("truncate", Truncate);
import { VTooltip, VPopover, VClosePopover } from 'v-tooltip'

Vue.directive('tooltip', VTooltip)
Vue.directive('close-popover', VClosePopover)
Vue.component('v-popover', VPopover)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
